import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  mainDiv: {
    minHeight: "inherit",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  mainActions: {
    height: 35,
    marginBottom: 12,
    marginLeft: 12,
    marginRight: 12,
    marginTop: 24,
    "& .deleteButton": {
      width: "50%",
    },
  },
  title: {
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#465869",
    height: "auto !important",
  },

  actionButtons: {
    width: "100%",
  },
  marginInput: {
    marginBottom: "15px",
  },
  dividerHorizontal: {
    padding: "15px 0px",
    height: "1px",
  },

  saveAndBook: {
    color: "#32D583",
    border: "1px solid #32D583",
    backgroundColor: "transparent",
    "&:hover": {
      color: "#6CE9A6",
      borderColor: "#6CE9A6",
      backgroundColor: "transparent",
    },
    "&:active": {
      border: "none",
    },
    "&:disabled": {
      border: "none",
    },
  },
}));

export default styles;
